<template>
  <section class="v-drawerSection">

    <!-- トグルボタン -->
    <button
      type="button"
      :title="$t('FilterAccordion.filterHeader')"
      @click.stop="toggleDrawer"
      :class="['v-drawerToggleButton', { 'is-opened': isOpened }]"
      data-ga-event-name="toggle_drawer"
      data-ga-event-area="filter_list"
    >
      <span class="v-icon-wrapper">
        <svg
          :class="['v-icon-svg', { 'is-visible': !isOpened }]"
          xmlns="http://www.w3.org/2000/svg"
          height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"
        >
          <path d="M455.39-180q-15.08 0-25.23-10.16Q420-200.31 420-215.39v-231.53L191-738.08q-10.92-12.77-3.04-27.34 7.89-14.58 23.5-14.58h537.08q15.61 0 23.5 14.58 7.88 14.57-3.04 27.34L540-446.92v231.53q0 15.08-10.16 25.23Q519.69-180 504.61-180h-49.22ZM480-444.46l228.85-290.15h-457.7L480-444.46Z"/>
        </svg>
        <svg
          :class="['v-icon-svg', { 'is-visible': isOpened }]"
          xmlns="http://www.w3.org/2000/svg"
          height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"
        >
          <path d="M480-448 266.92-234.92q-6.69 6.69-15.8 6.88-9.12.19-16.2-6.88-7.07-7.08-7.07-16 0-8.93 7.07-16L448-480 234.92-693.08q-6.69-6.69-6.88-15.8-.19-9.12 6.88-16.2 7.08-7.07 16-7.07 8.93 0 16 7.07L480-512l213.08-213.08q6.69-6.69 15.8-6.88 9.12-.19 16.2 6.88 7.07 7.08 7.07 16 0 8.93-7.07 16L512-480l213.08 213.08q6.69 6.69 6.88 15.8.19 9.12-6.88 16.2-7.08 7.07-16 7.07-8.93 0-16-7.07L480-448Z"/>
        </svg>
      </span>
    </button>

    <!-- ドロワーパネル -->
    <div :class="['v-drawer-slide-wrapper', { 'is-opened': isOpened }]">
      <div class="v-drawer--panel" @click.stop>
        <div class="v-drawer--body">
          <div
            class="v-controls__switchImgs v-photoButtons"
            v-if="!( ['/favorite_rings'].includes($pathname) )"
          >
            <template v-for="btn in filteredPhotoButtons">
              <button
                :key="btn.value"
                :title="btn.title ? btn.title : $t(btn.titleKey)"
                :class="['v-button', localPhotoMode === btn.value ? 'is-selected' : '']"
                data-ga-event-name="switch_images"
                data-ga-event-area="collection_controls"
                :data-ga-event-value="btn.value"
                @click="switchPhotoMode(btn.value)"
              >
                {{ btn.text ? btn.text : $t(btn.textKey) }}
              </button>
            </template>
          </div>

          <filter-list
            v-for="(filter, index) in filteredFilterLists"
            :key="index"
            :listTitle="$t(filter.titleKey)"
            :list="getList(filter.key)"
            :selectedList="getList(filter.selectedKey)"
            @item-click="(value) => handleItemClick(filter.selectedKey, value)"
          />

          <div v-show="metals.length || textures.length || types.length">
            <button class="v-button" @click="onClearClick">{{ $t("FilterAccordion.clear") }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- オーバーレイ -->
    <div
      class="v-drawerOverlay"
      :class="{ 'is-opened': isOpened }"
      @click="closeDrawer"
    ></div>

  </section>
</template>

<script>
import FilterList from './FilterList.vue'

export default {
  name: 'FilterDrawer',
  components: { FilterList },
  props: {
    photoMode: { type: String, default: "single_color_bg" },
    bgMode: { type: String, default: "" },
    designs: { type: Array, default: () => [] },
    selectedDesigns: { type: Array, default: () => [] },
    tastes: { type: Array, default: () => [] },
    selectedTastes: { type: Array, default: () => [] },
    metals: { type: Array, default: () => [] },
    selectedMetals: { type: Array, default: () => [] },
    textures: { type: Array, default: () => [] },
    selectedTextures: { type: Array, default: () => [] },
    series: { type: Array, default: () => [] },
    selectedSeries: { type: Array, default: () => [] },
    otherFilters: { type: Array, default: () => [] },
    selectedOtherFitlers: { type: Array, default: () => [] },
    types: { type: Array, default: () => [] },
    $pathname: { type: String, default: "" }
  },
  data () {
    return {
      isOpened: false,
      localPhotoMode: this.photoMode,
      localBgMode: this.bgMode,
    }
  },
  computed: {
    filteredFilterLists() {
      return this.filterLists.filter(filter => this.getList(filter.key).length);
    },
    filterLists() {
      return [
        { key: 'designs', titleKey: 'FilterList.listTitle.design', selectedKey: 'selectedDesigns' },
        { key: 'tastes', titleKey: 'FilterList.listTitle.taste', selectedKey: 'selectedTastes' },
        { key: 'metals', titleKey: 'FilterList.listTitle.bullion', selectedKey: 'selectedMetals' },
        { key: 'textures', titleKey: 'FilterList.listTitle.texture', selectedKey: 'selectedTextures' },
        { key: 'series', titleKey: 'FilterList.listTitle.series', selectedKey: 'selectedSeries' },
        { key: 'otherFilters', titleKey: 'FilterList.listTitle.otherFilter', selectedKey: 'selectedOtherFitlers' }
      ]
    },
    filteredPhotoButtons() {
      return this.photoButtons.filter(btn => btn.show);
    },
    photoButtons() {
      return [
        { value: 'single_color_bg', titleKey: 'Main.photoButtons.imageTitle1', textKey: 'Main.photoButtons.image1', show: true },
        { value: 'main', titleKey: 'Main.photoButtons.imageTitle2', textKey: 'Main.photoButtons.image2', show: !(['/set_rings'].includes(this.pathname)) },
        { value: 'sub', titleKey: 'Main.photoButtons.imageTitle3', textKey: 'Main.photoButtons.image3', show: !(['/set_rings'].includes(this.pathname)) },
        { value: 'hand', titleKey: 'Main.photoButtons.imageTitleWorn', textKey: 'Main.photoButtons.worn', show: true }
      ]
    }
  },
  watch: {
    photoMode(newVal) {
      this.localPhotoMode = newVal;
    },
    bgMode(newVal) {
      this.localBgMode = newVal;
    },
    localPhotoMode(newVal) {
      this.$emit('update:photoMode', newVal);
    },
    localBgMode(newVal) {
      this.$emit('update:bgMode', newVal);
    }
  },
  methods: {
    openDrawer () {
      this.isOpened = true
    },
    closeDrawer () {
      this.isOpened = false
    },
    toggleDrawer() {
      if (this.isOpened) {
        this.closeDrawer()
      } else {
        this.openDrawer()
      }
    },
    switchPhotoMode(newMode) {
      this.localPhotoMode = newMode
      this.localBgMode = ''
    },
    getList(key) {
      return this[key] || []
    },
    handleItemClick(dataName, item) {
      this.$emit('update-item', { dataName, item })
    },
    onClearClick(e) {
      this.$emit('clear-all', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-drawerSection {
  position: relative;
}

.v-drawerToggleButton {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: var(--color-ith-blue);
  border: 0;
  color: #fff;
  font: inherit;
  padding: 0;
  outline: 0;
  position: fixed;
  bottom: 45px;
  right: 5px;
  width: 45px;
  height: 45px;
  border-radius: 1000px;
  z-index: 1006;
  transition: right 0.3s var(--animation-easing);
  font-size: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 900px) {
    bottom: 15px;
    right: 15px;

    --content-max-width: 1200px;
    --button-size: 45px;
    right: calc( (100vw - var(--content-max-width)) / 2 - var(--button-size) );
  }
}

.v-icon-wrapper {
  --drawer-toggle-icon-size: 24px;
  position: relative;
  width: var(--drawer-toggle-icon-size);
  height: var(--drawer-toggle-icon-size);
}

.v-icon-svg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.2s var(--animation-easing);
  opacity: 0;
}

.v-icon-svg.is-visible {
  opacity: 1;
}

/* オーバーレイもアニメーション */
.v-drawerOverlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s var(--animation-easing);
  z-index: 1003;
  pointer-events: none;
}

.v-drawerOverlay.is-opened {
  opacity: 1;
  pointer-events: auto;
}

.v-drawer-slide-wrapper {
  --drawer-max-width: 414px;
  --drawer-margin: 40px;
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 1005;
  transform: translateX(100%);
  transition: transform 0.4s var(--animation-easing);
  will-change: transform;
  backface-visibility: hidden;
  width: calc(100% - var(--drawer-margin));
  max-width: var(--drawer-max-width); /* ドロワー幅制限だけmax */

  &.is-opened {
    transform: translateX(0%);
  }

  @media screen and (min-width: 900px) {
    max-width: 50%;
  }
}

.v-drawer--panel {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  padding: 60px 20px 100px;
  backface-visibility: hidden;
}

.v-photoButtons {
  display: flex;
//  flex-wrap: wrap;
  gap: 10px;
  margin: 0 0 10px;
}
</style>
